import React from 'react';

import StarActiveIcon from './images/star-active.svg';
import {Image} from "../components/image/image";
import {BaseProps} from "../../infrastructure/models/props/base-props";

export class StarQualifiedProps extends BaseProps {
  width: Number;
  height: Number;
  className: String;
}

export const StarQualified = ({width, height, className} : StarQualifiedProps) => {
  return <Image src={StarActiveIcon} width={width} height={height} className={className}/>
}
